module.exports = "/call-frontend/img/assistant_avatar_light.17157998.png";